import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { useContext, useEffect, useState } from 'react'

// Internal components
import PlayerList from '../PlayerList/PlayerList'
import Svg from '../Svg/Svg'
import { UserContext } from '../../context/UserContext'

const FormationOverlay = (props) => {
  const { modifiers, selectedSpot, setSelectedSpot, newInitialLineUp, setNewInitialLineUp, availablePlayers } = props

  const userContext = useContext(UserContext)
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const [teamPlayers, setTeamPlayers] = useState([])
  const [selectedModalPlayer, setSelectedModalPlayer] = useState(null)

  useEffect(() => {
    if (!availablePlayers) return false
    const activePlayers = []
    newInitialLineUp.forEach((player) => {
      activePlayers.push(player.uuid)
    })
    const newList = [...availablePlayers].map((player) => {
      delete player.inField

      if (activePlayers.includes(player.uuid)) {
        player.inField = true
      }
      return player
    })
    setTeamPlayers(newList)
  }, [newInitialLineUp])

  useEffect(() => {
    newInitialLineUp.forEach((player, index) => {
      if (index === selectedSpot) {
        if (player.icon === 'change') {
          setSelectedModalPlayer(player)
        }
      }
    })
  }, [selectedSpot])

  const handleClose = () => {
    setSelectedModalPlayer(null)
    setSelectedSpot(null)
  }
  return (
    <div className={`FormationOverlay${modifierClasses} ${selectedSpot || selectedSpot === 0 ? 'is-shown' : ''}`}>
      <div className="FormationOverlay-close" onClick={() => handleClose()}>
        <Svg id="icon-close" modifiers={['FormationOverlay-closeIcon']} />
      </div>
      <h3 className="FormationOverlay-header">
        {selectedModalPlayer ? (
          <>
            <Svg id="icon-substitute" modifiers={['FormationOverlay-substitute']} />
            {t('MDL__TXT_SUBSTITUTE')} {selectedModalPlayer.name}
          </>
        ) : (
          <>
            <Svg id="icon-add" modifiers={['FormationOverlay-add']} />
            {t('MDL__TXT_CHOOSEPLAYER')}
          </>
        )}
      </h3>
      <em className="FormationOverlay-subtitle">
        {' '}
        {teamPlayers.length} {t('MDL__TXT_PLAYERCOUNT')}{' '}
      </em>
      <PlayerList
        playerList={[teamPlayers]}
        clickablePlayers="modal"
        selectedSpot={selectedSpot}
        setSelectedSpot={setSelectedSpot}
        setSelectedModalPlayer={setSelectedModalPlayer}
        newInitialLineUp={newInitialLineUp}
        setNewInitialLineUp={setNewInitialLineUp}
      />
    </div>
  )
}

FormationOverlay.defaultProps = {
  modifiers: [],
  selectedSpot: 0,
  setSelectedSpot: () => {},
  newInitialLineUp: [],
  setNewInitialLineUp: () => {},
  availablePlayers: []
}

FormationOverlay.propTypes = {
  modifiers: PropTypes.array,
  selectedSpot: PropTypes.number,
  setSelectedSpot: PropTypes.func,
  newInitialLineUp: PropTypes.array,
  setNewInitialLineUp: PropTypes.func,
  availablePlayers: PropTypes.array
}

export default FormationOverlay
